var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homePage pageContainer"},[_c('p',[_c('span',{staticClass:"username"},[_vm._v("\n      "+_vm._s(_vm.userName)+"\n   ")]),_c('span',[_vm._v("\n      欢迎来到官网后台管理系统\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }